import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";

const CreditNoteFormFields = ({
  firms,
  financialYears,
  customers,
  selectedFirm,
  selectedFY,
  selectedCustomer,
  setSelectedFirm,
  setSelectedFY,
  handleCustomerChange,
  invoices,
  selectedInvoices,
  handleInvoiceSelection,
}) => {
  const canShowInvoices = selectedCustomer && selectedFirm && selectedFY;

  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <FormControl fullWidth>
          <InputLabel>Firm</InputLabel>
          <Select
            value={selectedFirm}
            label="Firm"
            onChange={(e) => setSelectedFirm(e.target.value)}
          >
            {firms.map((f) => (
              <MenuItem key={f.id} value={f.id}>
                {f.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <FormControl fullWidth>
          <InputLabel>Financial Year</InputLabel>
          <Select
            value={selectedFY}
            label="Financial Year"
            onChange={(e) => setSelectedFY(e.target.value)}
          >
            {financialYears.map((fy) => (
              <MenuItem key={fy.id} value={fy.id}>
                {fy.description}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <FormControl fullWidth>
          <InputLabel>Customer</InputLabel>
          <Select
            value={selectedCustomer}
            label="Customer"
            onChange={(e) => handleCustomerChange(e.target.value)}
          >
            {customers.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.name} ({c.account_number || "No A/C"})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <FormControl fullWidth disabled={!canShowInvoices}>
          <InputLabel>GST Invoices</InputLabel>
          <Select
            multiple
            value={selectedInvoices}
            onChange={(e) => handleInvoiceSelection(e.target.value)}
            input={<OutlinedInput label="GST Invoices" />}
            renderValue={(selected) =>
              selected
                .map((id) => {
                  const inv = invoices.find((inv) => inv.id === id);
                  return inv ? `#${inv.invoice_number}` : id;
                })
                .join(", ")
            }
          >
            {canShowInvoices &&
              invoices.map((inv) => (
                <MenuItem key={inv.id} value={inv.id}>
                  <Checkbox checked={selectedInvoices.includes(inv.id)} />
                  <ListItemText primary={`#${inv.invoice_number}`} />
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default CreditNoteFormFields;